// const { BASE_URL } = process.env;

// eslint-disable-next-line no-undef
const baseURL = process.env.REACT_APP_API_URL;

export default {
    BaseURL: baseURL,
};
